import Entity from '../app/entity'

export default new Entity(null, 0)
